import PropTypes from 'prop-types';
import * as yup from 'yup';
import { useFormik } from 'formik';
import { Button, TextField } from '@mui/material';
import { AvlModal } from '../AvlModal/AvlModal';
import { setFolderMaintenance } from '../../../Services/Search.services';

const validationSchema = yup.object().shape({
    userName: yup.string().email('Invalid email address').required('Required'),
});

const MaintenanceModeModal = ({ isOpen, folderId, onClose, onSuccess }) => {
    const formik = useFormik({
        initialValues: { userName: '' },
        validationSchema,
        onSubmit: async (values, { setSubmitting }) => {
            await setFolderMaintenance(folderId, { is_maintenance: true, user_name: values.userName });
            setSubmitting(false);
            handleClose();
            onSuccess();
        },
    });

    const handleClose = () => {
        formik.resetForm();
        onClose();
    };

    return (
        <AvlModal
            isOpen={isOpen}
            onClose={handleClose}
            title='Enable Maintenance Mode'
            maxWidth='500px'
            actionButtons={[
                <Button
                    key='cancel'
                    variant='outlined'
                    onClick={handleClose}
                    disabled={formik.isSubmitting}
                >
                    Cancel
                </Button>,
                <Button
                    key='confirm'
                    variant='contained'
                    onClick={formik.submitForm}
                    disabled={formik.isSubmitting || !formik.isValid || !formik.dirty}
                >
                    Enable
                </Button>,
            ]}
        >
            <TextField
                fullWidth
                size='small'
                label='User (email)'
                name='userName'
                value={formik.values.userName}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.userName && Boolean(formik.errors.userName)}
                helperText={
                    formik.touched.userName && formik.errors.userName
                        ? formik.errors.userName
                        : 'User under whose name all operations will be recorded'
                }
            />
        </AvlModal>
    );
};

MaintenanceModeModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    folderId: PropTypes.string.isRequired,
    onClose: PropTypes.func.isRequired,
    onSuccess: PropTypes.func.isRequired,
};

export default MaintenanceModeModal;
